import { message, Flex, Typography, Modal } from 'antd';
import form, { FormInstance } from 'antd/es/form';
import { CustomButton } from '../ui';
import { useBlocker } from 'react-router';
import { Profile } from '@/pages/my-profile/general';

interface Props {
  formChanged: boolean;
  onFinish: (values: any) => void;
  form: FormInstance<Partial<Profile>>;
}

export default function Blocker({ formChanged, onFinish, form }: Props) {
  let blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      formChanged && currentLocation.pathname !== nextLocation.pathname,
  );

  if (blocker.state === 'blocked') {
    return (
      <Modal
        open={blocker.state === 'blocked'}
        onCancel={() => {
          blocker?.reset?.();
        }}
        onOk={async () => {
          try {
            const values = await form.validateFields();

            await onFinish(values);
            blocker?.proceed?.();
          } catch (error) {
            message.error('Validation failed please check the form again.');
            blocker?.reset?.();
          }
        }}
        footer={null}
        styles={{
          mask: {
            backdropFilter: 'blur(10px)',
            backgroundColor: 'rgba(0, 0, 0, 0.3)',
          },
        }}
        centered
        width={460}
        className={'my-profile-modal'}
      >
        <Flex vertical gap={16} className={'modal-content'}>
          <Typography.Text className={'title'}>
            {'Leave without saving?'}
          </Typography.Text>

          <Typography.Text className={'description'}>
            {
              'You have unsaved changes. Are you sure you want to leave without saving?'
            }
          </Typography.Text>
        </Flex>

        <Flex vertical gap={12}>
          <CustomButton
            type={'primary'}
            text={'SAVE AND LEAVE'}
            onClick={async () => {
              try {
                const values = await form.validateFields();

                await onFinish(values);
                blocker?.proceed?.();
              } catch (error) {
                message.error(
                  'Please correct the highlighted fields before leaving this section.',
                );
                blocker?.reset?.();
              }
            }}
          />
          <CustomButton
            type={'default'}
            text={'LEAVE WITHOUT SAVING'}
            onClick={() => {
              blocker?.proceed?.();
            }}
          />
        </Flex>
      </Modal>
    );
  } else {
    return null;
  }
}
